import { AU, BR, EEA, Regions, SG, TR, US } from '@/modules/configs/region'
import auSrc from '@/modules/images/region-popup/au-round.svg'
import brSrc from '@/modules/images/region-popup/br-round.svg'
import eeaSrc from '@/modules/images/region-popup/eea-round.svg'
import sgSrc from '@/modules/images/region-popup/sg-round.svg'
import trSrc from '@/modules/images/region-popup/tr-round.svg'
import usSrc from '@/modules/images/region-popup/us-round.svg'

// NOTE/TODO SG only show the indicator not region switcher
export const userRegionIndicator = (userRegion: Regions) => {
  if (userRegion === SG) {
    return sgSrc
  }

  if (userRegion === BR) {
    return brSrc
  }

  if (userRegion === US) {
    return usSrc
  }

  if (userRegion === AU) {
    return auSrc
  }

  if (userRegion === EEA) {
    return eeaSrc
  }

  if (userRegion === TR) {
    return trSrc
  }

  return ''
}
